import { initBox, initClose } from "./box";
import { initMount } from "./mount";
import { initBanner } from "./banner";
import { initInsert } from "./insert";
let width;
let height;
export const getSize = () => {
    return { width, height };
};
export const render = (option) => {
    try {
        const box = initBox(option);
        width = option.width;
        height = option.height;
        const { close, play, pause } = initClose({
            ...option,
            ...option.adContent,
        });
        const mediaBox = document.createElement("div");
        mediaBox.style.position = "relative";
        mediaBox.style.zIndex = (option.zIndex + 1).toString();
        mediaBox.style.width = "100%";
        mediaBox.style.height = "100%";
        box.appendChild(close);
        const media = (() => {
            switch (option.adContent.adTypeCode) {
                case "SPLASH":
                    return initMount(option.adContent, play, pause);
                case "FIRST":
                    return initMount(option.adContent, play, pause);
                case "BANNER":
                    return initBanner(option.adContent, play, pause);
                case "REWARDED":
                    return initInsert(option.adContent, play, pause);
                default:
                    return initBanner(option.adContent, play, pause);
            }
        })();
        media.style.position = "relative";
        media.style.zIndex = (option.zIndex + 2).toString();
        media.style.width = "100%";
        media.style.height = "100%";
        media.style.cursor = "pointer";
        media.style.overflow = "hidden";
        mediaBox.appendChild(media);
        option.onView();
        mediaBox.addEventListener("click", (event) => {
            switch (option.adContent.eventType) {
                case "CLICK": {
                    window.open(option.adContent.eventLink, "_black");
                    break;
                }
                case "VIEW": {
                    window.open(option.adContent.eventLink, "_black");
                }
                default: {
                    window.open(option.adContent.eventLink, "_black");
                }
            }
            option.onClick();
            event.stopPropagation();
            event.preventDefault();
        });
        let overTimer;
        const initOnOver = () => {
            overTimer = setTimeout(() => {
                option.onOver();
                if (option.loop) {
                    initOnOver();
                }
            }, option.adContent.dur * 1000);
        };
        const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                option.onStart();
                initOnOver();
            }
            else {
                clearTimeout(overTimer);
            }
        });
        observer.observe(box);
        box.appendChild(mediaBox);
        return box;
    }
    catch (err) {
        option.onError(err);
        return document.createElement("div");
    }
};
export default render;
//# sourceMappingURL=index.js.map